module.exports = __webpack_public_path__ + "img/gerawappen.cd8c06a7.png";